import React, { memo } from "react";
import { Add } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import { CompanyMachineProcessCard } from "@component";
import EditMachineSlider from "./editMachineSlider/EditMachineSlider";
import machineController from "./machine.controller";
import { MachineProps } from "./machine.interface";
import { StyledContainer, StyledText } from "../process/process.style";
import {
  StyledList,
  StyledListContainer,
} from "@component/usersFromCountries/usersFromCountries.style";
import {
  StyledFabButton,
  StyledFabButtonContainer,
} from "../products/products.style";

const Machine: React.FC<MachineProps> = ({ userId }) => {
  const {
    machineData,
    handleCloseDrawer,
    handleOpenDrawer,
    index,
    openDrawer,
    removeMachine,
    loading,
    machineId,
  } = machineController({ userId });
  const theme = useTheme();
  return (
    <>
      {machineData.length !== 0 ? (
        <StyledListContainer>
          <StyledList>
            {machineData?.map((item) => (
              <CompanyMachineProcessCard
                item={item}
                key={item._id}
                onEditIcon={(id) => handleOpenDrawer(id)}
                onDeleteIcon={(id) => removeMachine(id)}
                loading={loading}
                id={machineId}
              />
            ))}
          </StyledList>
        </StyledListContainer>
      ) : (
        <StyledContainer>
          <StyledText>Nothing to show here</StyledText>
        </StyledContainer>
      )}
      {openDrawer && (
        <EditMachineSlider
          openDrawer={openDrawer}
          handleCloseIcon={handleCloseDrawer}
          machineId={index}
          userId={userId}
        />
      )}
      <StyledFabButtonContainer>
        <StyledFabButton
          sx={{ top: "-19%", [theme.breakpoints.down("sm")]: { top: "-23%" } }}
          color="primary"
          onClick={() => handleOpenDrawer()}
        >
          <Add />
        </StyledFabButton>
      </StyledFabButtonContainer>
    </>
  );
};

export default memo(Machine);
